import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import LayoutNotLogged from "@/pages/Layout/LayoutNotLogged.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";
import Login from "@/pages/Login.vue";
import ModificaDati from "@/pages/ModificaDati.vue";
import AggiungiDati from "@/pages/AggiungiDati.vue";
import CercaPratiche from "@/pages/CercaPratiche.vue";
import NotificaEmail from "@/pages/NotificaEmail.vue";
import DataPreventivo from "@/pages/DataPreventivo.vue";
import Dashboard from "@/pages/Dashboard.vue";
import Attivita from "@/pages/Attivita/Attivita.vue";
import Amministrazione from "@/pages/Amministrazione.vue";
import AggiungiProva from "@/pages/AggiungiProva.vue";
import PraticheSingoloUtente from "@/pages/PraticheSingoloUtente.vue";
//checklist
import Checklist from "@/pages/Checklist/CheckList.vue";
import Checklist1 from "@/pages/Checklist/Checklist1.vue";


//ANTIRICICLAGGIO
import Cliente from "@/pages/Antiriciclaggio/Cliente.vue";
import CreaCliente from "@/pages/Antiriciclaggio/CreaCliente.vue";
import CaricaFileCliente from "@/pages/Antiriciclaggio/CaricaFileCliente.vue";
import Av3 from "@/pages/Antiriciclaggio/AV3.vue";
import AnagraficaSoggetti from "@/pages/Antiriciclaggio/AnagraficaSoggetti.vue";
import CreaSoggetto from "@/pages/Antiriciclaggio/CreaSoggetto.vue";
import CaricaFileSoggetto from "@/pages/Antiriciclaggio/CaricaFileSoggetto.vue";
import Prestazioni from "@/pages/Antiriciclaggio/Prestazioni.vue";
import CreaPrestazione from "@/pages/Antiriciclaggio/CreaPrestazione.vue";
import Valutazione from "@/pages/Antiriciclaggio/Valutazione.vue";
import ValutazioneTabA from "@/pages/Antiriciclaggio/ValutazioneTabA.vue";
import ValutazioneTabB from "@/pages/Antiriciclaggio/ValutazioneTabB.vue";
import CreaValutazione from "@/pages/Antiriciclaggio/CreaValutazione.vue";
import DashboardAntiriciclaggio from "@/pages/Antiriciclaggio/DashboardAntiriciclaggio.vue";
import ResponsabiliAntiriciclaggio from "@/pages/Antiriciclaggio/ResponsabiliAntiriciclaggio.vue";
import ProfiloUfficioAttivo from "@/pages/Antiriciclaggio/ProfiloUfficioAttivo.vue";
import AggiornaRischio from "@/pages/Antiriciclaggio/AggiornaRischio.vue";
import Riassunto from "@/pages/Antiriciclaggio/Riassunto.vue";


//NOTE DI CREDITO
import NoteCredito from "@/pages/NoteCredito/NoteCredito.vue";
import CreaNotaCredito from "@/pages/NoteCredito/CreaNotaCredito.vue";
import ModificaNotaCredito from "@/pages/NoteCredito/ModificaNotaCredito.vue";
import NotificaNotaCredito from "@/pages/NoteCredito/NotificaNotaCredito.vue";
import CaricaFileNotaCredito from "@/pages/NoteCredito/CaricaFileNotaCredito.vue";

//CORSI
import CorsiDashboard from "@/pages/Corsi/CorsiDashboard.vue";
import ModificaCorso from "@/pages/Corsi/ModificaCorso.vue";
import ModificaCorsista from "@/pages/Corsi/ModificaCorsista.vue";
import PaginaIniziale from "@/pages/Corsi/PaginaIniziale.vue";

// import ProvaBar from "@/pages/Corsi/ProvaBar.vue";

// ASSEVERAZIONI
import AsseverazioniDashboard from "@/pages/Asseverazione/AsseverazioniDashboard.vue";
import CreaAsseverazione from "@/pages/Asseverazione/CreaAsseverazione.vue";
import ModificaAsseverazione from "@/pages/Asseverazione/ModificaAsseverazione.vue";
import NotificaAsseverazione from "@/pages/Asseverazione/NotificaAsseverazione.vue";

// prova CHAT
import ProvaChat from '@/pages/Chat/ProvaChat.vue';

// Admin pages
//const Dashboard = () => import(/* webpackChunkName: "dashboard" */"@/pages/Dashboard.vue");
// localStorage.setItem('user_livello', '1');
const livello = localStorage.getItem('user_livello');
console.log(`livello = ${livello}`)

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/login",
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.length==0) {
            next({ path: "/login" });
          } else {
            next();
          }
        }
      },
      {
        path: "aggiungi-dati",
        name: "aggiungi-dati",
        component: AggiungiDati,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.length==0) {
            next({ path: "/" });
          } else {
            next();
          }
        }
      },
      {
        path: "modifica-dati",
        name: "modifica-dati",
        component: ModificaDati,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.length==0) {
            next({ path: "/" });
          } else {
            next();
          }
        }
      },
      {
        path: "pratiche-singolo",
        name: "pratiche-singolo",
        component: PraticheSingoloUtente,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.length==0) {
            next({ path: "/login" });
          } else {
            next();
          }
        }
      },
      {
        path: "cerca-pratiche",
        name: "cerca-pratiche",
        component: CercaPratiche,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.length==0) {
            next({ path: "/" });
          } else {
            next();
          }
        }
      },
      // CHECKLIST
      {
        path: "checklist",
        name: "checklist",
        component: Checklist
      },
      {
        path: "Checklist1",
        name: "Checklist1",
        component: Checklist1
      },
      {
        path: "attivita",
        name: "attivita",
        component: Attivita,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.length==0) {
            next({ path: "/" });
          } else {
            next();
          }
        }
      },
      {
        path: "amministrazione",
        name: "amministrazione",
        component: Amministrazione,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.length==0) {
            next({ path: "/" });
          } else {
            next();
          }
        }
      },
      // ANTIRICICLAGGIO
      {
        path: "clienti",
        name: "clienti",
        component: Cliente,
      },
      {
        path: "crea-cliente",
        name: "crea-cliente",
        component: CreaCliente,
      },
      {
        path: "uploadfile-cliente",
        name: "uploadfile-cliente",
        component: CaricaFileCliente,
      },
      {
        path: "av3",
        name: "av3",
        component: Av3,
      },
      {
        path: "anagrafica-soggetti",
        name: "anagrafica soggetti",
        component: AnagraficaSoggetti
      },
      {
        path: "crea-soggetto",
        name: "crea soggetto",
        component: CreaSoggetto
      },
      {
        path: "uploadfile-soggetto",
        name: "uploadfile-soggetto",
        component: CaricaFileSoggetto,
      },
      {
        path: "prestazioni",
        name: "prestazioni",
        component: Prestazioni
      },
      {
        path: "crea-prestazione",
        name: "crea prestazione",
        component: CreaPrestazione
      },
      {
        path: "valutazione",
        name: "valutazione",
        component: Valutazione
      },
      {
        path: "valutazione-a",
        name: "valutazione tab A",
        component: ValutazioneTabA
      },
      {
        path: "valutazione-b",
        name: "valutazione tab B",
        component: ValutazioneTabB
      },
      {
        path: "crea-valutazione",
        name: "crea valutazione",
        component: CreaValutazione
      },
      {
        path: "dashboard-antiriciclaggio",
        name: "dashboard-antiriciclaggio",
        component: DashboardAntiriciclaggio,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.getItem("isLogged") === 'undefined'  || localStorage.length==0) {
            next({ path: "/" });
          } else {
            next();
          }
        }
      },
      {
        path: "responsabile-antiriciclaggio",
        name: "responsabile-antiriciclaggio",
        component: ResponsabiliAntiriciclaggio,
      },
      {
        path: "profilo-ufficio-attivo",
        name: "profilo-ufficio-attivo",
        component: ProfiloUfficioAttivo,
      },
      {
        path: "aggiorna-rischio",
        name: "aggiorna-rischio",
        component: AggiornaRischio,
      },
      {
        path: "riassunto",
        name: "riassunto",
        component: Riassunto
      },

      // NOTA DI CREDITO
      {
        path: "note-credito",
        name: "note-credito",
        component: NoteCredito,
        /*DA SCOMMENTARE QUANDO LO METTO SU*/
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.getItem("isLogged") === 'undefined'  || localStorage.length==0) {
            next({ path: "/" });
          } else {
            next();
          }
        }
      },
      {
        path: "crea-nota",
        name: "crea-nota",
        component: CreaNotaCredito,
        /*DA SCOMMENTARE QUANDO LO METTO SU*/
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.getItem("isLogged") === 'undefined'  || localStorage.length==0) {
            next({ path: "/" });
          } else {
            next();
          }
        }
      },
      {
        path: "modifica-nota",
        name: "modifica-nota",
        component: ModificaNotaCredito,
        /*DA SCOMMENTARE QUANDO LO METTO SU */
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.getItem("isLogged") === 'undefined' || localStorage.length==0) {
            next({ path: "/" });
          } else {
            next();
          }
        }
      },
      {
        path: "uploadfile-nota",
        name: "uploadfile-nota",
        component: CaricaFileNotaCredito,
        /*DA SCOMMENTARE QUANDO LO METTO SU */
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.getItem("isLogged") === 'undefined'  || localStorage.length==0) {
            next({ path: "/" });
          } else {
            next();
          }
        }
      },
      {
        path: "prova-chat",
        name: "prova-chat",
        component: ProvaChat,
      },
      //CORSI
      {
        path: "corsi",
        name: "corsi",
        component: CorsiDashboard,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.getItem("isLogged") === 'undefined'  || localStorage.length==0) {
            next({ path: "/" });
          } else {
            next();
          }
        }
      },
      {
        path: "modifica-corso",
        name: "modifica-corso",
        component: ModificaCorso,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.getItem("isLogged") === 'undefined'  || localStorage.length==0) {
            next({ path: "/" });
          } else {
            next();
          }
        }
      },
      {
        path: "modifica-corsista",
        name: "modifica-corsista",
        component: ModificaCorsista,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.getItem("isLogged") === 'undefined') {
            next({ path: "/" });
          } else {
              next();
          }
        }
      },
      {
        path: "pagina-corsi",
        name: "pagina-corsi",
        component: PaginaIniziale
      },
      // {
      //   path: "prova",
      //   name: "prova",
      //   component: ProvaBar,
      // },
      // ASSEVERAZIONI
      {
        path: "asseverazioni",
        name: "asseverazioni",
        component: AsseverazioniDashboard,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.getItem("isLogged") === 'undefined') {
            next({ path: "/" });
          } else {
              next();
          }
        }
      },
      {
        path: "crea-asseverazione",
        name: "crea-asseverazione",
        component: CreaAsseverazione,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.getItem("isLogged") === 'undefined') {
            next({ path: "/" });
          } else {
              next();
          }
        }
      },
      {
        path: "modifica-asseverazione",
        name: "modifica-asseverazione",
        component: ModificaAsseverazione,
        beforeEnter: (to, from, next) => {
          if (localStorage.getItem("isLogged") === 'false' || localStorage.getItem("isLogged") === 'undefined') {
            next({ path: "/" });
          } else {
              next();
          }
        }
      },
    ]
  },
  {
    path: "/",
    component: LayoutNotLogged,
    redirect: "/login",
    children: [
      {
        path: "login",
        name: "login",
        component: Login,
        beforeEnter: (to, from, next) => {
          if ( localStorage.getItem("isLogged") === 'true') {
            next({ path: "/dashboard" });
          } else {
            next();
          }
        }
      },
      {
        path: "notifica-email",
        name: "notifica-email",
        component: NotificaEmail
      },
      {
        path: "data-preventivo",
        name: "data-preventivo",
        component: DataPreventivo
      },
      {
        path: "notifica-nota",
        name: "notifica-nota",
        component: NotificaNotaCredito,
      },
      {
        path: "notifica-asseverazione",
        name: "notifica-asseverazione",
        component: NotificaAsseverazione,
      },
    ]
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
